export default [
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Home.vue'),

    meta: {
      auth: ['administrador'],
      title: 'Administrador',
    },

    children: [
      {
        path: '',
        name: 'administrador',
        redirect: { name: 'admin_pedido' },
      },
      {
        path: 'pedido',
        name: 'admin_pedido',
        component: () => import(/* webpackChunkName: "admin_pedido" */ '@/views/admin/nuevo_pedido/home.vue'),
        meta: {
          title: 'Recepción de mercancia',
        },
      },
      {
        path: '/admin/pedidos-activos',
        name: 'admin_pedidos_activos',
        component: () => import(/* webpackChunkName: "admin_pedidos_activos" */ '@/views/admin/pedidos_activos/home.vue'),
        meta: {
          title: 'Pedidos activos',
        },
      },
      {
        path: '/admin/historico',
        name: 'admin_historico',
        component: () => import(/* webpackChunkName: "admin_historico" */ '@/views/admin/historico/home.vue'),
        meta: {
          title: 'Historico de pedidos',
        },
      },
      {
        path: '/admin/sistema',
        name: 'admin_sistema',
        component: () => import(/* webpackChunkName: "admin_sistema" */ '@/views/admin/sistema/home.vue'),
        meta: {
          title: 'Administración del sistema',
        },
      },
    ],
  },
]
